import "./App.css"

export const Home = () => {
  return <div>
    
    <div>Hello Home</div>
    <a href="/astro-medallion/">Astro Medallion</a><br/>
    <a href="/tutor/">Tutor</a>
  </div>
}
